export enum InspireReport {
  /// Personal Development Chart
  Pdc = 0,
  /// Manager Development Chart
  Mdc = 1,
  /// Behavioral Report
  Behavioral = 2,
  /// Management Strategy Guide
  Msg = 3,
  /// Relationship Guide
  RelationshipGuide = 4,
  /// Self Concept
  SelfConcept = 5,
  /// Placard
  Placard = 6,
  /// Coaching Guide
  CoachingGuide = 7,
  /// Management tips
  ManagementTips = 8,
}
